import {
    h,
    ref,
    Teleport,
    onMounted,
    computed,
    renderSlot,
} from 'vue'

import every from 'lodash/every'

import {
    AField
} from '../AField'

import './aselect.scss'

import {
    useASelect
} from './ASelect'

import {
    useGetSlots
} from '../utils/composables'

const ASelect = {
    name: 'ASelect',
    props: {
        modelValue: {
            required: false,
            default: ''
        },
        dropdownClasses: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
            validator(value) {
                return every(value, option => Object.keys(option).includes('title') && Object.keys(option).includes('value'))
            }
        },
        staticLabel: {
            type: Boolean,
            default: false,
        },
        emptyOptions: {
            type: String,
            default: 'No options'
        },
        multiple: Boolean,
        filtering: Boolean,
        searchInputSize: {
            type: Number,
            default: 3
        },
        addMode: Boolean,
        tags: {
            type: Boolean,
            default: false,
        },
        hideSelected: {
            type: Boolean,
            default: false,
        },
        hideOnSelect: Boolean,
        display: {
            type: String,
            default: 'value'
        },
        value: {
            type: String,
            default: 'value'
        },
        error: {
            type: Boolean,
            default: false,
        },
        separator: {
            type: String,
            default: ', '
        },
        label: String,
        placeholder: {
            type: String,
            default: '',
        },
        hint: String,
        validator: {
            type: Function,
        },
        state: {
            type: Object,
            default: () => ({
                error: false,
                errorMsg: null
            })
        },
    },
    inheritAttrs: false,
    setup: (props, ctx) => {

        const field = ref(null)
        const target = ref(null)
        const control = ref(null)
        const input = ref(null)

        const {
            store,
            toggleShow,
            onFocusin,
            onFocusout,
            show,
            hide,
            backspaceRemove,
            chipRemove,
            addNewValue,
            popupClick,
            popupFocusin,
            popupFocusout,
            findValue,
            selectValue,
            onSearchFocus,
            onSearchBlur,
            onSearchInput,
            positionDetect,
        } = useASelect(props, ctx)

        onMounted(() => {
            store.field = field
            store.input = input
            store.target = target
            store.control = control

            var options = {
                rootMargin: '0px',
            }
            document.querySelectorAll('.a-select').forEach(function (module) {
                function moduleAnimation() {
                    positionDetect()
                }

                new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            window.addEventListener('scroll', moduleAnimation, true);
                        } else {
                            window.removeEventListener('scroll', moduleAnimation, true);
                        }
                    });
                }).observe(module);
            })
        })

        const findOjectValue = (key, value) => {
            if(props.addMode) {
                return value
            } else {
                const val = props.options.filter(row => {
                    return row[key] == value
                })

                if(val.length > 0) {
                    return val[0][props.display]
                }
            }
        }

        const renderValues = () => {
            if(props.tags) {
                return props.modelValue ? props.modelValue.map((row, i) => h('div', {
                    class: ['a-chip'],
                }, [
                    h('div', {
                        class: ['a-chip-value']
                    }, findOjectValue(props.value, row)),
                    h('span', {
                        class: ['a-chip-remove'],
                        onClick: () => chipRemove(i),
                    }, [
                        h('svg', {
                            width: 16,
                            height: 16,
                            xmlns: 'http://www.w3.org/2000/svg',
                            viewBox: '0 0 24 24',
                        }, [
                            h('path', {
                                d: 'M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z',
                            })
                        ])
                    ])
                ])) : ''
            } else {
                // return store.displayValue.split(',').map((row) => h('div', {
                //     class: ['a-select-val-item']
                // }, row.trim()))
                return store.displayValue
            }
        }

        const renderSelect = () => h(AField, {
            class: [store.state, ctx.attrs.class],
            validator: props.validator,
            modelValue: props.modelValue,
            ref: 'field',
            ...props,

            onMousedown: $e => toggleShow($e),
            onFocusin: $e => onFocusin($e),
            onFocusout: $e => onFocusout($e)
        }, {
            control: (props) => h('div', {
                class: ['a-select'],
                ref: 'control',
                tabindex: -1,
            }, [
                h('div', {
                    class: ['a-select-inner']
                }, [
                    h('div', {
                        class: ['a-select-placeholder'],
                        innerText: props.placeholder,
                    }),
                    h('div', {
                        class: ['a-select-val'],
                        // innerText: renderValues()//store.displayValue
                    }, renderValues()),
                    renderInput(),
                ]),
                h('svg', {
                    class: ['a-select-icon', store.state.show && 'active'],
                    viewbox: '0 0 12 8',
                    ariaHidden: true,
                    role: 'presentation',
                    height: 8,
                    width: 12,
                }, [
                    h('rect', {
                        width: 2,
                        height: 8,
                        rx: 1,
                        transform: 'matrix(0.707107 -0.707107 -0.707107 -0.707107 6.34375 7.53552)',
                    }),
                    h('rect', {
                        width: 8,
                        height: 2,
                        rx: 1,
                        transform: 'matrix(0.707107 -0.707107 -0.707107 -0.707107 6.34375 7.53552)',
                    })
                ]),
                store.state.show ? renderPopup() : void 0,
            ]),
            ...useGetSlots(ctx.slots, props),
        })

        const renderInput = () => {
            if (props.filtering || props.addMode) {
                return h('input', {
                    ref: 'input',
                    type: 'text',
                    class: ['a-select-input'],
                    value: store.filtering,
                    onFocus: $e => onSearchFocus($e),
                    onBlur: $e => onSearchBlur($e),
                    onInput: $e => onSearchInput($e),
                    onKeydown: $e => {
                        backspaceRemove($e)
                        addNewValue($e)
                    }
                })
            }
        }

        const renderPopup = () => h(Teleport, {
            to: 'body'
        }, [
            h('div', {
                    class: ['a-dropdown', props.dropdownClasses],
                    ref: 'target',
                    tabindex: -1,
                    style: store.popup,
                    onClick: $e => popupClick($e),
                    onFocusin: $e => popupFocusin($e),
                    onFocusout: $e => popupFocusout($e),
                },
                renderOptions(store.options)
            )
        ])

        const renderOptions = () => store.options.length > 0 ? store.options.map((item) => {
            item.selected = findValue(item) || false
            if(props.hideSelected) {

                if(!findValue(item)) {
                    return h('div', {
                        class: ['a-item', findValue(item) && 'active'],
                        onClick: $e => selectValue(item)
                    }, [
                        ctx.slots.item !== void 0 ?
                        ctx.slots.item(item)
                        : typeof item === 'object' ? item[props.display] : item
                    ])
                }

            } else {
                return h('div', {
                    class: ['a-item', findValue(item) && 'active'],
                    onClick: $e => selectValue(item)
                }, [
                    ctx.slots.item !== void 0 ?
                    ctx.slots.item(item)
                    : typeof item === 'object' ? item[props.display] : item
                ])
            }
        }) :
        h('div', {class: ['a-item']}, props.emptyOptions)

        const validate = () => {
            if (!field.value.validate()) {
                field.value.store.state.error = true
                ctx.emit('error', { status: false, msg: field.value.store.errorMsg })
            }
        }

        return {
            store,
            renderSelect,
            field,
            target,
            input,
            control,
            validate
        }
    },
    render() {
        return this.renderSelect()
    },
}

export {
    ASelect
}